@if (due().length) {
  <div class="rmq" role="region" aria-label="Due reminders">
    <app-button
      class="rmq-label-host"
      variant="text"
      tone="neutral"
      icon="notifications"
      iconWidth="14px"
      iconHeight="14px"
      iconFill="currentColor"
      extraClass="rmq-label"
      [attr.title]="labelTitle()"
      (btnOnClick)="openAll()"
    >
      <span>Due reminders</span>
      <span class="rmq-count" [class.is-capped]="capped()">{{ countLabel() }}</span>
    </app-button>

    <div class="rmq-list">
      @for (r of inline(); track r.id) {
        <div class="rmq-item" [class.is-busy]="busyId() === r.id">
          <span class="rmq-time" [title]="'Due ' + timeLabel(r)">
            <app-svg-icons icons="clock" width="12" height="12" />
            {{ timeLabel(r) }}
          </span>
          <app-button class="rmq-title-host" variant="text" tone="neutral" size="xs" [title]="r.title" extraClass="rmq-title" [attr.title]="r.title" (btnOnClick)="open(r)" />
          <span class="rmq-dismiss">
            <app-button
              icon="task-alt"
              title="Dismiss"
              variant="ghost"
              tone="neutral"
              size="xs"
              iconWidth="13px"
              iconHeight="13px"
              iconFill="currentColor"
              [disabled]="busyId() === r.id"
              (btnOnClick)="dismiss(r)"
            />
          </span>
          <span class="rmq-snooze" role="group" [attr.aria-label]="'Snooze ' + r.title">
            <span class="rmq-snooze-label"><app-svg-icons icons="snooze" width="12" height="12" />Snooze</span>
            @for (m of snoozePresets; track m) {
              <app-button
                class="rmq-preset-host"
                variant="text"
                tone="neutral"
                size="xs"
                [title]="snoozeLabel(m)"
                extraClass="rmq-preset"
                [attr.title]="snoozeTitle(m)"
                [disabled]="busyId() === r.id"
                (btnOnClick)="snooze(r, m)"
              />
            }
          </span>
        </div>
      }
    </div>

    <div class="rmq-controls">
      @if (overflowCount()) {
        <app-button variant="outlined" tone="neutral" size="xs" [title]="'+' + overflowCount() + ' more'" extraClass="rmq-more" [attr.title]="'Open my reminders'" (btnOnClick)="openAll()" />
      }
      <app-button
        icon="refresh"
        [iconOnly]="true"
        variant="ghost"
        tone="neutral"
        size="xs"
        iconWidth="13px"
        iconHeight="13px"
        iconFill="currentColor"
        [extraClass]="loading() ? 'rmq-refreshing' : ''"
        [disabled]="loading()"
        ariaLabel="Refresh reminders"
        (btnOnClick)="refresh()"
      />
    </div>
  </div>
}
